<template>
  <div>
    <div v-if="title" class="py-2 my-2 text-xl font-semibold leading-7 text-gray-500 sm:truncate sm:text-xl sm:tracking-tight mb-4">Transcript</div>

    <div class="flow-root my-4 font-source">
      <ul role="list" class="-mb-8">
        <li v-for="(transcriptItem, transcriptItemIdx) in conversationTranscriptMessages" :key="transcriptItem.ts">
          <div class="relative pb-6">
            <span v-if="transcriptItemIdx !== conversationTranscriptMessages.length - 1" class="absolute left-5 top-5 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true" />
            <div class="relative flex items-start space-x-3">
              <mdicon
                :name="transcriptItem[actorProp].toLowerCase() === 'bot' ? 'cog' : transcriptItem[actorProp].toLowerCase() === 'agent' ? 'face-agent' : 'account'"
                size="26"
                class="flex h-10 w-10 items-center justify-center rounded-full bg-slate-100 ring-8 ring-white"
              />
              <div class="min-w-0 flex-1">
                <div>
                  <div class="text-sm">
                    {{ formatSeconds(transcriptItem.at) }} {{ transcriptItem.actor }} <span class="font-semibold">{{ transcriptItem.name }}</span>
                  </div>
                  <!--<p class="mt-0.5 text-sm text-gray-500">{{ formatEntryTime(transcriptItem.ts) }}</p>-->
                </div>
                <div :class="['mt-2', getMessageTextClass(transcriptItem)]" v-html="getMessageHtml(transcriptItem)"></div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { pathOr } from 'ramda';
  import { formatSeconds } from '@/utils/formatSeconds';
  import { useMd } from '@/hooks/useMd';

  const props = defineProps({
    conversation: {
      type: Object,
      default() {
        return {};
      },
    },
    transcriptMessagesPath: {
      type: Array,
      default() {
        return ['context', 'transcript', 'messages'];
      },
    },
    actorProp: {
      type: String,
      default: 'actor',
    },
    textProp: {
      type: String,
      default: 'message',
    },
    title: {
      type: String,
      default: 'Transcript',
    },
  });

  const md = useMd();

  const actorsInfo = {
    customer: {
      name: 'User',
      type: 'user',
      icon: 'account',
      textClass: 'text-md text-gray-700 font-medium bg-slate-50 rounded-md px-2 py-1 -ml-2',
      titleClass: 'text-sm',
      iconClass: 'rounded-full bg-slate-100',
    },
    bot: {
      name: 'Bot',
      type: 'bot',
      icon: 'account-multiple',
      textClass: 'prose font-source text-md bg-violet-50 rounded-md px-2 py-1 -ml-2 text-slate-600',
      titleClass: 'text-sm',
      iconClass: 'rounded-full bg-violet-100',
    },
    assistant: {
      name: 'Bot',
      type: 'bot',
      icon: 'account-multiple',
      textClass: 'prose font-source text-md bg-violet-50 rounded-md px-2 py-1 -ml-2 text-slate-600',
      titleClass: 'text-sm',
      iconClass: 'rounded-full bg-violet-100',
    },
    agent: { name: 'Agent', type: 'agent', icon: 'face-agent', textClass: 'text-md text-gray-700 font-medium bg-orange-50 rounded-md px-2 py-1 -ml-2', titleClass: 'text-sm', iconClass: 'rounded-full bg-orange-100' },
  };

  function getActorInfo(msg) {
    const actor = (msg[props.actorProp] || 'system').toLowerCase();
    return actorsInfo[actor] || actorsInfo['system'];
  }

  //const conversationTranscript = computed(() => props.conversation?.context?.transcript || {});
  //const conversationTranscriptMetadata = computed(() => conversationTranscript.value?.metadata || {});
  const conversationTranscriptMessages = computed(() => {
    //conversationTranscript.value?.messages || conversationTranscript.value?.data ||
    return pathOr([], props.transcriptMessagesPath, props.conversation);
  });

  function getMessageHtml(transcriptItem) {
    return md.mdToHtml(transcriptItem[props.textProp] || '');
  }

  function getMessageTextClass(transcriptItem) {
    return getActorInfo(transcriptItem)?.textClass || 'text-md text-gray-700';
  }
</script>
